import { API_GET_EXTERNAL_SERVICES_STATUS } from "actions/externalServices";

export function getExternalServicesStatus() {
	return {
		type: API_GET_EXTERNAL_SERVICES_STATUS,
		payload: {
			request: {
				url: `/externalServices`,
				method: "get",
			},
		},
	};
}
